import IconButton from '@mui/material/IconButton';
import type React from 'react';
import { useState } from 'react';

import { EyeIcon, EyeShowIcon } from '../../../assets/icons';
import Input, { type Props } from '../Input/Input';

const NumericPassword: React.FC<Props> = (props) => {
  const [isPasswordShown, setIsPasswordShown] = useState(false);

  const numsOnly = (value: string) => value.replace(/[^\d]/g, '');

  const Icon = isPasswordShown ? EyeShowIcon : EyeIcon;

  // TODO: Use translation https://jira.pyrsoftware.ca/jira/browse/LMS-18949 when is ready
  const message = {
    id: '1',
    defaultMessage: 'Toggle password visibility'
  };
  return (
    <Input
      {...props}
      showValidationTick={false}
      type={isPasswordShown ? 'text' : 'password'}
      parse={numsOnly}
      numericKeyboard
    >
      <IconButton
        aria-label={message.defaultMessage}
        onClick={() => setIsPasswordShown(!isPasswordShown)}
        size="small"
      >
        <Icon />
      </IconButton>
    </Input>
  );
};

export default NumericPassword;
